import { Add as AddIcon, GetApp as GetAppIcon } from "@mui/icons-material";
import { Box, Button, Container, Fab, Tooltip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { PageHeader } from "src/components/page/PageHeader";
import { BackgroundConcentrationTable } from "src/components/BackgroundConcentrationTable";
import { usePermissions } from "src/hooks";
import { useTemplates } from "src/hooks";
import { isDisabled } from "src/utils/permission.utils";
import { useBackgroundConcentrations } from "src/hooks/background-concentrations";
import { IsEnabled } from "src/components/permissions";

interface Props {}

export function BackgroundConcentrationsPage(props: Props) {
  const { t } = useTranslation();
  const { data: permissions } = usePermissions();
  const { data: templates } = useTemplates();
  const { data: backgroundConcentrations } = useBackgroundConcentrations();

  return render();

  function render() {
    if (!backgroundConcentrations || !permissions || !templates) return null;

    return (
      <StyledContainer maxWidth="lg">
        <PageHeader>
          <Typography variant="h3" noWrap className="page-title">
            {t("title.backgroundConcentrationManagement")}
          </Typography>
          <Box display="flex" flexGrow={1} />

          <Button
            className="button"
            component="a"
            startIcon={<GetAppIcon />}
            href={templates.backgroundTemplateUrl}
            download
            disabled={isDisabled(permissions.background.downloadTemplate)}
          >
            {t("label.templateFile")}
          </Button>

          <IsEnabled permission={permissions.background.create}>
            <Tooltip title={t<string>("tooltip.newBackgroundConcentration")} placement="left">
              <Fab className="button fab" color="primary" aria-label="add">
                <AddIcon />
              </Fab>
            </Tooltip>
          </IsEnabled>
        </PageHeader>

        <BackgroundConcentrationTable className="background-concentrations-table" data={backgroundConcentrations} />
      </StyledContainer>
    );
  }
}

const StyledContainer = styled(Container)`
  padding: ${({ theme }) => theme.spacing(3)};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .page-title {
    margin-bottom: ${({ theme }) => theme.spacing(3)};
  }

  .background-concentrations-table {
    height: 0;
    flex: 1 1 100px;
  }

  .button {
    & + .button {
      margin-left: ${({ theme }) => theme.spacing(1)};
    }
  }
`;
